// extracted by mini-css-extract-plugin
export default {"cls1":"LsUv345gz0KEugNjSqtF","cls2":"ejvRMB8oTVZDNTyovTAC LsUv345gz0KEugNjSqtF","isPhone":"fprHxBJ5DcKt9Mr0n08K"};